// extracted by mini-css-extract-plugin
export var active = "fc-multi-cards-module--active--89fff";
export var item = "fc-multi-cards-module--item--d38e4";
export var items = "fc-multi-cards-module--items--7ad9c";
export var root = "fc-multi-cards-module--root--bdcf8";
export var subtitle = "fc-multi-cards-module--subtitle--ebb37";
export var title = "fc-multi-cards-module--title--1b985";
export var toggle = "fc-multi-cards-module--toggle--6093a";
export var toggles = "fc-multi-cards-module--toggles--8a0b5";